<template>
  <footer class="footer">
    <span>{{ organization }}</span>
    <br>
    <span v-if="copyrightPrefix">{{ copyrightPrefix }}</span>
    <a :href="project.href">{{ project.label }}</a>
    <span v-if="copyrightSuffix">{{ copyrightSuffix }}</span>
  </footer>
</template>

<script setup>
defineProps({
  organization: {
    type: String,
    default: "WIDE Cloud Working Group"
  },
  copyrightPrefix: {
    type: String,
    default: "© 2010 Yuji Sekiya / "
  },
  project: {
    type: Object,
    default: () => ({ label: "WIDE Project", href: "http://www.wide.ad.jp/" })
  },
  copyrightSuffix: {
    type: String,
    default: " All Rights Reserved"
  }
})
</script>
